import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom"; // Prefer Link over <a> for SPA behavior
import boloLogo from "../assets/bolo-logo.jpg";

// --- Styles ---

const Wrapper = styled.div`
  min-height: 100vh;
  background: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Wave = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 43vh;
  background: #1a1a1a;
  border-bottom-left-radius: 40% 10%;
  border-bottom-right-radius: 40% 10%;
  z-index: 1;
`;

const Logo = styled.img`
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  width: 160px;
  z-index: 2;
`;

const Content = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  margin-top: 43vh;
  flex: 1;
`;

const Headline = styled.h1`
  color: #222;
  font-size: 2rem;
  margin-bottom: 18px;
  text-align: center;
`;

const Tagline = styled.p`
  color: #444;
  font-size: 1.1rem;
  margin-bottom: 0;
  text-align: center;
`;

const MainButton = styled.button`
  background: #ffd166;
  color: #222;
  border: none;
  border-radius: 32px;
  padding: 16px 0;
  font-size: 1.08rem;
  width: 88%;
  max-width: 350px;
  font-weight: 600;
  margin: 40px 0 0 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  display: block;
`;

const LoginText = styled.p`
  color: #666;
  margin: 24px 0 8px 0;
  font-size: 1rem;
`;

const LoginButton = styled.button`
  background: transparent;
  color: #4285f4;
  border: 1px solid #4285f4;
  border-radius: 32px;
  padding: 14px 0;
  font-size: 1rem;
  width: 88%;
  max-width: 350px;
  font-weight: 600;
  cursor: pointer;
  display: block;
`;

const FooterLinks = styled.div`
  margin-top: 24px;
  text-align: center;
  font-size: 0.85rem;
  color: #666;
  padding: 0 24px;

  a {
    color: #217a53;
    text-decoration: underline;
    margin: 0 6px;
  }
`;

// --- Component ---

export default function WelcomeScreen({ onStartAssessment, onLogin }) {
  return (
    <Wrapper>
      <Wave />
      <Logo src={boloLogo} alt="Bolo Logo" />
      <Content>
        <Headline>Ready for a Little Self-Discovery?</Headline>
        <Tagline>
          Your habits, your hidden strengths, your next breakthrough.
          <br />
          Take our 2-minute quiz and see yourself in a whole new light.
        </Tagline>

        <MainButton
          onClick={() => {
            console.log("Start My Discovery clicked");
            if (typeof onStartAssessment === "function") onStartAssessment();
          }}
        >
          Start My Discovery
        </MainButton>

        <LoginText>Already a user? Log in below.</LoginText>

        <LoginButton
          onClick={() => {
            console.log("Log In clicked");
            if (typeof onLogin === "function") onLogin();
          }}
        >
          Log In
        </LoginButton>

        <FooterLinks>
          By using this app, you agree to our
          <Link to="/privacy-policy">Privacy Policy</Link>
          and
          <Link to="/data-deletion">Right to Be Forgotten</Link>.
        </FooterLinks>
      </Content>
    </Wrapper>
  );
}
